import React, { Component } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import AddtoSlack from "../assets/AddtoSlack.png"

const SlackButtonWrapper = styled.div`
  height: 50px;
  width: 200px;
  background-color: white;
  background-image: url('${AddtoSlack}');
  background-position: center;
  background-size: cover;
  border-radius: 7px;
  box-shadow: ${props =>
    props.darkShadow
      ? `0px 5px 15px rgba(34,34,50,.5)`
      : `0px 5px 15px rgba(214,214,224,1)`};
  :hover {
    transform: scale(1.05);
    box-shadow: ${props =>
      props.darkShadow
        ? `0px 6px 30px rgba(34,34,50,.5)`
        : `0px 6px 30px rgba(214,214,224,1)`};
    transition: 200ms ease;
  }
  a {
    display: block;
    height: 100%;
    width: 100%;
  }

  @media (max-width: 786px) {
    transform: scale(.9);
    :hover {
      transform: scale(1);
    }
  }

  @media (max-width: 420px) {
    transform: scale(.8);
    :hover {
      transform: scale(.9);
    }
  }
`

const SlackLink = props => <Link to={props.to}>{props.children}</Link>

export default function({ darkShadow, className }) {
  return (
    <SlackButtonWrapper className={className} darkShadow={darkShadow}>
      <a href="https://slack.com/oauth/authorize?scope=files:read,channels:write,groups:write,bot,commands,chat:write:bot,users:read,team:read&client_id=73100902978.130145105494" />
    </SlackButtonWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/AddtoSlack.js